import { GoogleOAuthProvider } from '@react-oauth/google'
import React, { useEffect, createContext, useRef } from 'react'
import { getDomainSetting } from '@/lib/getDomainSettings'
import { INITIAL_SESSION, Session } from './AuthClient'
// Depuis ./session directement : passer par le ré-export de withAuthent fermait le cycle
// withAuthent → hooks → AuthProvider → withAuthent, traversé par toutes les pages protégées.
import { authClient } from './session'

function createSessionStore<T>(initial: T) {
  let session = initial
  const listeners = new Set<() => void>()

  return {
    get: () => session,
    set: (next: T | ((prev: T) => T)) => {
      session = typeof next === 'function' ? (next as (p: T) => T)(session) : next
      listeners.forEach(l => l())
    },
    subscribe: (listener: () => void) => {
      listeners.add(listener)
      return () => listeners.delete(listener)
    },
  }
}

type SessionStore<T> = ReturnType<typeof createSessionStore<T>>
export const AuthContext = createContext<SessionStore<Session> | null>(null)

const AuthProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const storeRef = useRef<SessionStore<Session> | null>(createSessionStore(INITIAL_SESSION))

  useEffect(() => {
    authClient.registerSessionChangeCallback(session => storeRef.current?.set(session))
  }, [])

  return (
    <AuthContext.Provider value={storeRef.current}>
      <GoogleOAuthProvider clientId={getDomainSetting('googleSsoClientId')}>
        {children}
      </GoogleOAuthProvider>
    </AuthContext.Provider>
  )
}

export default AuthProvider
